export const topCountriesData =[
    {
        color:"primary",
        img:"04",
        country:"Uniter States",
        percentage:"60%",
        countrybadge:"primary",
    },
    {
        color:"secondary",
        img:"05",
        country:"Germany",
        percentage:"51%",
        countrybadge:"secondary",
    },
    {
        color:"dark",
        img:"06",
        country:"New Zealand",
        percentage:"52%",
        countrybadge:"dark",
    },
    {
        color:"warning",
        img:"07",
        country:"Australia",
        percentage:"62%",
        countrybadge:"warning",
    }
]